const replaceItem = (list, identifier, idValue, newValue) => {
  const index = list.findIndex((item) => item[identifier] === idValue);
  if (index === -1) {
    return [
      ...list,
      {
        ...{
          [identifier]: idValue,
        },
        ...newValue,
      },
    ];
  }

  return [
    ...list.slice(0, index),
    {
      ...list[index],
      ...newValue,
    },
    ...list.slice(index + 1, list.length),
  ];
};

export default replaceItem;
